import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getOrderByNumber } from '../api/api';
import './OrderConfirmation.css';

function OrderConfirmation() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderNumber]);

  const fetchOrder = async () => {
    try {
      const response = await getOrderByNumber(orderNumber);
      setOrder(response.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="container"><p>Loading...</p></div>;
  if (!order) return <div className="container"><p>Order not found</p></div>;

  return (
    <div className="order-confirmation container">
      <div className="success-icon">✓</div>
      <h1>Order Confirmed!</h1>
      <p className="thank-you">Thank you for your purchase</p>
      
      <div className="order-details">
        <h2>Order Number: {order.orderNumber}</h2>
        <p>A confirmation email has been sent to {order.customer.email}</p>
        
        <div className="order-summary">
          <h3>Order Summary</h3>
          {order.items.map((item, index) => (
            <div key={index} className="order-item">
              <span>{item.productName} x {item.quantity}</span>
              <span>R{(item.price * item.quantity).toFixed(2)}</span>
            </div>
          ))}
          <div className="order-total">
            <span>Total:</span>
            <span>R{order.total.toFixed(2)}</span>
          </div>
        </div>

        <div className="shipping-info">
          <h3>Shipping Address</h3>
          <p>
            {order.shippingAddress.street}<br/>
            {order.shippingAddress.city}, {order.shippingAddress.state}<br/>
            {order.shippingAddress.postalCode}<br/>
            {order.shippingAddress.country}
          </p>
        </div>
      </div>
    </div>
  );
}

export default OrderConfirmation;
